<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08" right :timeout="timeout">
      <v-layout wrap>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="snackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 pb-lg-12 pb-5><v-divider></v-divider></v-flex>
      <v-flex xs10 md11 lg10 pb-lg-12 pb-5>
        <v-layout wrap px-lg-12>
          <!-- <v-flex xs12 md6 align-self-center v-if="productDetail.photos">
          <v-img
            :style="
              $vuetify.breakpoint.name == 'xs'
                ? 'width:100%'
                : $vuetify.breakpoint.name == 'sm'
                ? 'width:50%'
                : (style = 'width:100%')
            "
            contain
            :src="mediaURL + productDetail.photos[0]"
          >
          </v-img>
        </v-flex> -->
          <v-flex xs12 md6 align-self-center v-if="productDetail.photos">
            <v-card outlined tile elevation="0" height="70vh">
              <v-layout wrap justify-center fill-height>
                <v-flex xs12 text-center align-self-center>
                  <span class="hidden-md-and-up">
                    <v-img
                      v-if="!curImage"
                      :src="mediaURL + productDetail.photos[0]"
                      max-height="60vh"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="#FF2323"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-if="curImage"
                      :src="mediaURL + curImage"
                      max-height="60vh"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="#FF2323"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </span>
                  <span class="hidden-sm-and-down">
                    <image-magnifier
                      v-if="!curImage"
                      :src="mediaURL + productDetail.photos[0]"
                      :zoom-src="mediaURL + productDetail.photos[0]"
                      width="400"
                      height="300"
                      zoom-width="400"
                      zoom-height="300"
                    ></image-magnifier>
                    <image-magnifier
                      v-if="curImage"
                      :src="mediaURL + curImage"
                      :zoom-src="mediaURL + curImage"
                      width="400"
                      height="300"
                      zoom-width="400"
                      zoom-height="300"
                    ></image-magnifier>
                  </span>
                </v-flex>
                <v-flex xs11>
                  <v-card tile flat>
                    <v-layout wrap justify-center>
                      <v-flex
                        xs2
                        v-for="(item, i) in productDetail.photos"
                        :key="i"
                      >
                        <v-card @click="showImage(item)" flat tile>
                          <v-layout wrap justify-center>
                            <v-flex pa-2>
                              <v-img
                                :src="mediaURL + item"
                                height="100px"
                                contain
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="#FEBD08"
                                    ></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex md6 lg5 pl-md-12 pt-sm-3>
            <v-layout wrap>
              <v-flex
                xs12
                py-3
                style="font-size: 25px; font-family: robotoregular"
                >{{ productDetail.productName }}
              </v-flex>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs6 sm3 md5 lg4
                    ><v-rating
                      :value="parseFloat(productDetail.rating)"
                      color="amber"
                      background-color="#C7BCBC"
                      half-increments
                      length="5"
                      readonly
                      size="14"
                    ></v-rating>
                  </v-flex>
                  <v-flex pl-lg-5 xs6 align-self-center>
                    <span>{{ productDetail.totalReviews }} Reviews</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pt-3>
                <span
                  v-if="newprice <= 0"
                  style="font-weight: bold; font-size: 21px"
                  >Rs. {{ offerPrice }}
                </span>
                <span v-else style="font-weight: bold; font-size: 21px"
                  >Rs. {{ newprice.toFixed(2) }}
                </span>
                <span
                  v-if="productDetail.price != productDetail.offerPrice"
                  style="color: gray; font-size: 21px; margin-left: 2%"
                >
                  <del> Rs. {{ productDetail.price }}</del></span
                >
              </v-flex>
              <v-flex py-3 xs12 class="text"
                >{{ productDetail.description }}
              </v-flex>
              <v-flex xs12 py-5><v-divider> </v-divider> </v-flex>
              <v-flex xs12>
                <v-layout wrap text-center>
                  <v-flex xs12 sm6 md6 lg7>
                    <v-layout wrap>
                      <v-flex>
                        <v-btn
                          outlined
                          width="100%"
                          tile
                          @click="qty--"
                          :disabled="qty <= 1"
                        >
                          <v-icon> mdi-minus </v-icon></v-btn
                        >
                      </v-flex>
                      <v-flex>
                        <v-btn outlined width="100%" tile>{{ qty }}kg</v-btn>
                      </v-flex>
                      <v-flex>
                        <v-btn
                          outlined
                          width="100%"
                          tile
                          @click="qty++"
                          :disabled="qty == productDetail.stockQuantity"
                        >
                          <v-icon> mdi-plus </v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md5
                    lg5
                    pt-4
                    pt-sm-0
                    pt-md-0
                    pl-2
                    v-if="!this.$store.state.isLoggedIn"
                  >
                    <v-btn
                      width="100%"
                      tile
                      @click="$router.push('/login')"
                      style="
                        font-family: robotoregular;
                        background-color: #febd08;
                        color: white;
                      "
                      elevation="0"
                    >
                      add to cart</v-btn
                    >
                  </v-flex>
                  <v-flex xs12 sm6 md5 lg5 pt-4 pt-sm-0 pt-md-0 pl-2 v-else>
                    <v-btn
                      v-if="productDetail.inCart == false"
                      width="100%"
                      tile
                      @click="addCart()"
                      style="
                        font-family: robotoregular;
                        background-color: #febd08;
                        color: white;
                      "
                      elevation="0"
                    >
                      add to cart</v-btn
                    >
                    <v-btn
                      v-else
                      width="100%"
                      tile
                      :to="'/cart'"
                      style="
                        font-family: robotoregular;
                        background-color: #febd08;
                        color: white;
                      "
                      elevation="0"
                    >
                      In cart
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 py-5><v-divider> </v-divider> </v-flex>
              <v-flex xs12> <v-spacer></v-spacer></v-flex>
              <v-flex xs12> <v-spacer> </v-spacer> </v-flex>
              <v-flex
                v-if="productDetail.benefits"
                xs12
                style="font-family: robotomedium"
              >
                BENEFITS
              </v-flex>
              <v-flex
                v-if="productDetail.benefits"
                xs12
                class="text"
                align-self-end
              >
                {{ productDetail.benefits }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-if="productDetail.uid">
        <Review v-bind:id="productDetail.uid._id" v-bind:storage="productDetail" />
      </v-flex>
      <v-flex xs12>
        <Similarproduct v-cloak v-bind:id="$route.query.searchkey" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import Review from "./customerReview";
import Similarproduct from "./similarProduct";
export default {
  components: {
    Review,
    Similarproduct,
  },
  data() {
    return {
      items: ["f2", "f1", "f3"],
      kg: "",
      productDetail: [],
      qty: 1,
      newprice: 0,
      curImage: null,
      msg: "",
      timeout: 5000,
      snackbar: false,
      appLoading: false,
      stockQuantity: null,
      offerPrice: null,
    };
  },
  watch: {
    qty() {
      this.newprice = this.qty * this.productDetail.offerPrice;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    showImage(item) {
      this.curImage = item;
    },
    changePrice(item) {
      this.stockQuantity = item;
      this.qty = 1;
      this.newprice = item.price;
      // alert( this.newprice)
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/get",
        // headers: {
        //   "x-auth-token": localStorage.getItem("token"),
        // },
        params: {
          id: this.$route.query.searchkey,
        },
      }).then((response) => {
        if (response.data.status) {
          this.productDetail = response.data.data;
          this.offerPrice = this.productDetail.offerPrice.toFixed(2);
          this.stockQuantity = this.productDetail.stockQuantity;
          this.appLoading = false;
        } else {
          console.log("no data ");
        }
      });
    },
    addCart() {
      // this.appLoading = true;
      var data = {};
      data["productId"] = this.$route.query.searchkey;
      data["quantity"] = this.qty;
      axios({
        method: "POST",
        url: "/cart/add",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Successfully added product to cart";
            this.$store.commit("changeCart", response.data.cart_length);
            this.getData();
            this.snackbar = true;
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>